import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Start Main 
import Header from './components/main/Header';
import Footer from './components/main/Footer';

// Start Pages
import Home from './components/pages/Home';
import AboutUs from './components/pages/AboutUs';
import Product from './components/pages/Product';
import ContactUs from './components/pages/ContactUs';
import MadeInJordan from './components/pages/MadeInJordan';
import ProductionLine from './components/pages/ProductionLine';

// Start Hooks
import Top from './components/Top';
import ScrollToTop from './components/ScrollToTop';
import UseScrollAnimation from './hooks/UseScrollAnimation';

const App = () => {
    return (
        <>
            <Header />
            <Top />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/product" element={<Product />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path='/made-in-jordan' element={<MadeInJordan />} />
                <Route path='/productionline' element={<ProductionLine />} />
            </Routes>

            <Footer />
            <ScrollToTop />
            <UseScrollAnimation />

        </>
    );
};

export default App;
